export const initialState = {
  artworkFile: {
    value: null,
    loading: false,
  },
  downloadingArtwork: false,
  editorUrl: {
    value: null,
    loading: false,
  },
  exportDocumentLoading: false,
  loadingDocument: false,
  loadingTemplate: false,
  saveDocumentLoading: false,
  selectedTemplate: null,
  templates: {
    value: [],
    loading: false,
  },
};
